import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import HomePageSettingMenu from "../common/homepageSettingMenu";
import RegisterMenu from "./registerMenu";
import HomepageNotice from "../common/homepageNotice";

import { setRegisterIndex } from "../../../../../store/compoIndex";
import { BoardWriteContainer, RegisterNoticeWriteFormContainer } from "../styled/register";
import { useModal } from "../../../../../hooks/useModal";
import { noticeMessages } from "../common/function/noticeMessages";

export default function RegisterNoticeWriteForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { modal, openModal, closeModal } = useModal();

  const setting = useSelector((state) => state?.user?.setting);
  const index = useSelector((state) => state.compoIndex.register);
  const user = useSelector((state) => state?.user?.data[0]);

  const isEdit = location?.state?.isEdit;
  const notice = location?.state?.notice;

  const titleRef = useRef();
  const contentRef = useRef();
  const selectList = ["공지", "일반", "상품안내", "포트폴리오", "결제 안내"];
  const [selected, setSelected] = useState(notice?.noticeCl || "공지");
  const [cmpnyNo, setCmpnyNo] = useState();

  useEffect(() => {
    const url = window.location.href;
    if (url.includes("register")) {
      dispatch(setRegisterIndex(3));
    }

    const company = JSON.parse(sessionStorage.getItem("homepageCompany"));

    if (!company) {
      console.log("선택된 회사가 존재하지 않습니다.");
      navigate("/mypage");
    } else {
      setCmpnyNo(company.cmpnyNo);
    }
  }, []);

  const saveNotice = async () => {
    const req = {
      cmpnyNo: cmpnyNo,
      noticeSj: titleRef.current.value,
      noticeCn: contentRef.current.value,
      noticeCl: selected,
      delYn: "N",
      createMberId: user?.userName,
      updateMberId: user?.userName,
      gbn: "N",
    };

    if (isEdit) {
      req.noticeNo = notice?.noticeNo;
    }
    try {
      const response = await axios.put("/api/notice", req);
      if (response.data.success === true) {
        toast.success(`공지사항이 ${isEdit ? "수정" : "등록"}되었습니다.`, {
          toastId: "no-access",
        });
        navigate("/mypage/register");
      }
    } catch (error) {
      console.log(error);
    } finally {
      closeModal();
    }
  };

  const checkValidation = () => {
    if (!titleRef.current.value) {
      toast.error(`제목을 입력해 주세요.`);
      return false;
    }
    if (!contentRef.current.value) {
      toast.error(`내용을 입력해 주세요.`);
      return false;
    }
    return true;
  };

  const handleSelect = (e) => {
    setSelected(e.target.value);
  };

  return (
    <>
      {modal}
      <RegisterNoticeWriteFormContainer className={setting?.mode}>
        <HomePageSettingMenu />
        <HomepageNotice message={noticeMessages[3]} />
        <RegisterMenu index={index} />
        <div className="inner_content_wrap">
          <BoardWriteContainer className={setting?.mode}>
            <ul>
              <li>
                <div className="writing_tit">제목</div>
                <div className="writing_cont">
                  <input
                    type="text"
                    placeholder="제목을 입력하세요."
                    defaultValue={notice?.noticeSj || ""}
                    ref={titleRef}
                    onChange={(e) => (titleRef.current.value = e.target.value)}
                  />
                </div>
              </li>
              <li>
                <div className="writing_tit">카테고리</div>
                <div className="writing_cont">
                  <select onChange={handleSelect} value={selected}>
                    {selectList.map((item, index) => (
                      <option value={item} key={index}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
              </li>
              <li>
                <div className="writing_tit">내용</div>
                <div className="writing_cont">
                  <textarea
                    defaultValue={notice?.noticeCn}
                    ref={contentRef}
                    onChange={(e) => (contentRef.current.value = e.target.value)}
                  />
                </div>
              </li>
            </ul>
          </BoardWriteContainer>
          <div className="actions">
            <button onClick={() => navigate("/mypage/register")}>
              <span>취소</span>
            </button>
            <button
              onClick={() => {
                if (!checkValidation()) {
                  return;
                }

                openModal({
                  isOpen: true,
                  type: "confirmation",
                  title: `공지 ${isEdit ? "수정" : "등록"}`,
                  message: [`공지사항을 ${isEdit ? "수정" : "등록"}하시겠습니까?`],
                  handleConfirm: () => saveNotice(),
                  handleCancel: () => closeModal(),
                });
              }}>
              <span>{isEdit ? "수정" : "등록"}</span>
            </button>
          </div>
        </div>
      </RegisterNoticeWriteFormContainer>
    </>
  );
}
